export default "__VITE_ASSET__Yh3$o6eA__"